<template>
    <b-modal
      id="tutorialsModal" 
      size="md" 
      content-class="menu-bg-blue-transparent-modal tut-modal"
      :title="tutorial ? 'Update Tutorial': 'Add New Tutorial'"
      hide-footer 
     
      @hide="reset()" 
    >
        <b-row class="px-4 pt-0" no-gutters>
            <b-col cols="12">
                <b-row>
                    <label>Name</label>
                </b-row>
                <b-row>
                    <b-form-input 
                      v-model="name" 
                      placeholder="Name..."
                      :class="missingFields.name ? 'red' : ''"
                      :disabled="tutorial ? true : false"
                    />
                </b-row>
            </b-col>
        </b-row>
        <b-row class="p-4" no-gutters>
            <b-col cols="12">
                <b-row>
                    <label>Description</label>
                </b-row>
                <b-row>
                    <b-textarea v-model="description" :class="missingFields.description ? 'red' : ''"></b-textarea>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="w-100" no-gutters>
            <b-col class="mx-auto" cols="auto">
                <b-button class="w-auto" variant="primary" @click="tutorial ? submitUpdate() : submitNew()">SUBMIT</b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<style scoped>
.red {
  border: 2px red solid;
  background-color: #FFCCCB;
}
</style>

<style>
.tut-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.tut-modal label { color: rgba(6, 60, 109, 0.7); }
.tut-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.tut-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.tut-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
</style>

<script>
import axios from 'axios'
export default {
    name: 'MMP_TutorialsModal',
    props: ['tutorial'],
    data() {
        return {
            name: null,
            description: null,
            missingFields: {
                name: false,
                description: false
            },
            submitErrors: []
        }
    },
    methods: {
        reset() {
            if (this.tutorial) {
                this.name = this.tutorial.name
                this.description = this.tutorial.description
            } else {
                this.name = null
                this.description = null
            }
            this.submitErrors = []
            this.missingFields = {
                name: false,
                description: false
            }
        },
        validateInput() {
            this.submitErrors = []
            if (!this.name) {
                this.submitErrors.push('name')
                this.missingFields.name = true;
            }
            if (!this.description){
                this.submitErrors.push('description')
                this.missingFields.description = true;
            }
        },
        async submitUpdate() {
            await this.validateInput();
            if (this.submitErrors.length) {
                let errMsg = 'The following fields need to be filled out: ' + this.submitErrors.join(', ') + '.'
                this.$bvToast.toast(errMsg, {
                    autoHideDelay: 5000,
                    title: 'Submission Error',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right'
                })
                setTimeout(() => {
                    this.missingFields = {
                        name: false,
                        description: false
                    }
                }, 5000)
            } else {
                if (sessionStorage.token) {
                    let body = {
                        id: this.tutorial.id,
                        name: this.name,
                        description: this.description
                    }
                    axios.put(process.env.API_LOCATION + '/api/tutorial/updateTutorial', body,
                        {
                            headers: {
                                'x-auth-token': sessionStorage.token
                            },
                        }
                    ).then(response => {
                        const content = response.data
                        if (content.errors) {
                            console.log(content.errors)
                        } else {
                            this.$bvToast.toast(content.message, {
                                autoHideDelay: 8000,
                                title: 'Submission Successful',
                                variant: 'success',
                                toaster: 'b-toaster-top-right'
                            })
                            this.$emit('refresh')
                            this.$bvModal.hide('tutorialsModal')
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                } else {
                    console.log('No User Token')
                    this.$router.push({name: 'Login'})
                }
            }
        },
        async submitNew() {
            await this.validateInput();
            if (this.submitErrors.length) {
                let errMsg = 'The following fields need to be filled out: ' + this.submitErrors.join(', ') + '.'
                this.$bvToast.toast(errMsg, {
                    autoHideDelay: 5000,
                    title: 'Submission Error',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right'
                })
                setTimeout(() => {
                    this.missingFields = {
                        name: false,
                        description: false
                    }
                }, 5000)
            } else {
                if (sessionStorage.token) {
                    let body = {
                        name: this.name,
                        description: this.description
                    }
                    axios.post(process.env.API_LOCATION + '/api/tutorial/', body,
                        {
                            headers: {
                                'x-auth-token': sessionStorage.token
                            },
                        }
                    ).then(response => {
                        const content = response.data
                        if (content.errors) {
                            console.log(content.errors)
                        } else {
                            this.$bvToast.toast(content.message, {
                                autoHideDelay: 8000,
                                title: 'Submission Successful',
                                variant: 'success',
                                toaster: 'b-toaster-top-right'
                            })
                            this.$emit('refresh')
                            this.$bvModal.hide('tutorialsModal')
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                } else {
                    console.log('No User Token')
                    this.$router.push({name: 'Login'})
                }
            }
        }
    },
    watch: {
        tutorial: function (newValue) {
            if (newValue) {
                this.name = newValue.name
                this.description = newValue.description
            } else {
                this.name = null
                this.description = null
            }
        }
    }
}
</script>